<div class="viewer-info-button-wrapper" (appClickOutside)="closePopup()">
  <button
    type="button"
    class="viewer-controller-icon-btn info-icon"
    [class.active]="isOpen"
    aria-label="Info"
    aria-haspopup="true"
    [attr.aria-expanded]="isOpen"
    (click)="togglePopup()">
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g class="info-icon-g">
        <path
          d="M7.54772 14.3747C11.3193 14.3747 14.3767 11.3173 14.3767 7.54577C14.3767 3.77423 11.3193 0.716797 7.54772 0.716797C3.77618 0.716797 0.71875 3.77423 0.71875 7.54577C0.71875 11.3173 3.77618 14.3747 7.54772 14.3747Z"
          stroke="currentColor"
          stroke-width="1.43315"
          stroke-linecap="round"
          stroke-linejoin="round" />
        <path
          d="M7.54688 10.96L7.54688 6.17968"
          stroke="currentColor"
          stroke-width="1.43315"
          stroke-linecap="round"
          stroke-linejoin="round" />
        <path
          d="M7.54688 4.13086L7.54587 4.13086"
          stroke="currentColor"
          stroke-width="1.43315"
          stroke-linecap="round"
          stroke-linejoin="round" />
      </g>
    </svg>
  </button>

  @if (file) {
    <div
      #popupEl
      class="viewer-info-popup"
      [class.visible]="isOpen"
      role="dialog"
      aria-label="Asset Information"
      [attr.aria-hidden]="!isOpen"
      [ngStyle]="useFixedPosition && popupFixedStyle ? popupFixedStyle : null">
      <div class="viewer-info-popup-inner">
        <div class="viewer-info-popup-header">
          <div class="viewer-info-popup-header-left">
            <span class="viewer-info-popup-icon" aria-hidden="true">
              <svg width="20" height="20" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M7.54772 14.3747C11.3193 14.3747 14.3767 11.3173 14.3767 7.54577C14.3767 3.77423 11.3193 0.716797 7.54772 0.716797C3.77618 0.716797 0.71875 3.77423 0.71875 7.54577C0.71875 11.3173 3.77618 14.3747 7.54772 14.3747Z"
                  stroke="currentColor"
                  stroke-width="1.43315"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
                <path
                  d="M7.54688 10.96L7.54688 6.17968"
                  stroke="currentColor"
                  stroke-width="1.43315"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
                <path
                  d="M7.54688 4.13086L7.54587 4.13086"
                  stroke="currentColor"
                  stroke-width="1.43315"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </span>
            <h2 class="viewer-info-popup-title">{{ popupTitle | translate }}</h2>
          </div>
          <button type="button" class="viewer-info-popup-close" aria-label="Close" (click)="closePopup()">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 4L4 12M4 4L12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
            </svg>
          </button>
        </div>

        <div class="viewer-info-popup-body">
          <section class="viewer-info-section">
            <h3 class="viewer-info-section-title">{{ 'file' | translate }}</h3>
            <dl class="viewer-info-list">
              <div class="viewer-info-row">
                <dt class="viewer-info-label">{{ 'fileName' | translate }}</dt>
                <dd class="viewer-info-value" [title]="viewerFile.displayName">{{ file.displayName }}</dd>
              </div>
              @if (viewerFile.size) {
                <div class="viewer-info-row">
                  <dt class="viewer-info-label">{{ 'fileSize' | translate }}</dt>
                  <dd class="viewer-info-value">{{ viewerFile.size | mtmFileSize }}</dd>
                </div>
              }
              @if (viewerFile.contentType) {
                <div class="viewer-info-row">
                  <dt class="viewer-info-label">{{ 'container' | translate }}</dt>
                  <dd class="viewer-info-value">{{ viewerFile.contentType }}</dd>
                </div>
              }
              @if (viewerFile.timeCreated) {
                <div class="viewer-info-row">
                  <dt class="viewer-info-label">{{ 'created' | translate }}</dt>
                  <dd class="viewer-info-value">{{ viewerFile.timeCreated | mtmDateTime }}</dd>
                </div>
              }
              @if (viewerFile.updated) {
                <div class="viewer-info-row">
                  <dt class="viewer-info-label">{{ 'modified' | translate }}</dt>
                  <dd class="viewer-info-value">{{ viewerFile.updated | mtmDateTime }}</dd>
                </div>
              }
            </dl>
          </section>

          @if (productionInfo) {
            <section class="viewer-info-section">
              <h3 class="viewer-info-section-title">{{ 'file_info_production' | translate }}</h3>
              <dl class="viewer-info-list">
                @if (productionInfo.camera) {
                  <div class="viewer-info-row">
                    <dt class="viewer-info-label">{{ 'camera' | translate }}</dt>
                    <dd class="viewer-info-value">{{ productionInfo.camera }}</dd>
                  </div>
                }
                @if (productionInfo.shotBy) {
                  <div class="viewer-info-row">
                    <dt class="viewer-info-label">{{ 'shot_by' | translate }}</dt>
                    <dd class="viewer-info-value">{{ productionInfo.shotBy }}</dd>
                  </div>
                }
                @if (productionInfo.lens) {
                  <div class="viewer-info-row">
                    <dt class="viewer-info-label">{{ 'lens' | translate }}</dt>
                    <dd class="viewer-info-value">{{ productionInfo.lens }}</dd>
                  </div>
                }
                @if (productionInfo.iso) {
                  <div class="viewer-info-row">
                    <dt class="viewer-info-label">ISO</dt>
                    <dd class="viewer-info-value">{{ productionInfo.iso }}</dd>
                  </div>
                }
                @if (productionInfo.shutter) {
                  <div class="viewer-info-row">
                    <dt class="viewer-info-label">{{ 'shutter' | translate }}</dt>
                    <dd class="viewer-info-value">{{ productionInfo.shutter }}</dd>
                  </div>
                }
              </dl>
            </section>
          }
        </div>
      </div>
    </div>
  }
</div>
